<div
  *ngIf="menuOpen"
  class="open__bg"
  (click)="closeMobileMenu.emit()"
  [@fadeInOnEnter]
  [@fadeOut]="triggerAnimOut"
></div>
<section class="container" [ngStyle]="bgColor$ | async">
  <header
    role="banner"
    class="nav nav--underline"
    [class.nav--collapse]="fixedMobileHeader$ | async"
    [class.sticky]="fixedMobileHeader$ | async"
  >
    <button
      mat-icon-button
      *ngIf="(isWeb$ | async) === false"
      class="btn-clean"
      type="button"
      (click)="openMobileMenu.emit()"
      aria-label="Ouvrir le menu"
    >
      <mat-icon svgIcon="burger" role="decoration"></mat-icon>
    </button>
    <!-- [routerLink]="['/']" -->
    <a
      [href]="homepageLink"
      ignoreExternLink
      aria-label="Retour à l'accueil"
      class="nav__1j1s-hashtag"
      *ngIf="(fixedMobileHeader$ | async) === true"
      [@fadeInOnEnter]
      [@fadeOutOnLeave]
      [@slideInDownOnEnter]
      [@slideOutUpOnLeave]
    >
      #1jeune1solution
    </a>

    <!-- [routerLink]="['/']" -->
    <a
      [href]="homepageLink"
      ignoreExternLink
      aria-label="Retour à l'accueil"
      (click)="trackEvent({ category: 'Navigation', action: 'Click Accueil', label: 'Logos 1J1S', type: 'navigation' })"
      *ngIf="(fixedMobileHeader$ | async) === false"
      class="nav__logos"
      [@fadeInOnEnter]
      [@fadeOutOnLeave]
      [@slideInDownOnEnter]
      [@slideOutUpOnLeave]
      [@.disabled]="(isWeb$ | async) === true"
    >
      <figure>
        <img
          class="nav__1j1s-travail"
          src="/assets/images/logo_rf.svg"
          alt="Logo République Française"
          role="presentation"
        />
        <img
          class="nav__1j1s-relance"
          src="/assets/images/logo1j1s-france-relance.svg"
          alt="Logo 1 jeune 1 solution et France Relance"
          role="presentation"
        />
      </figure>
    </a>

    <button
      type="button"
      class="btn-ghost avoidance-link"
      ngxScrollTo="#mainContent"
      [ngxScrollToOffset]="0"
      (click)="focusMainContent()"
    >
      Aller au contenu
    </button>

    <ul class="nav__buttons-holder" *ngIf="displayCompanySecureSpace || displayLocalMissionSecureSpace">
      <li *ngIf="displayCompanySecureSpace">
        <a
          [routerLink]="['/', FeaturesRoutingEnum.Companies, companyId, CompaniesRoutingEnum.SecureSpace]"
          class="btn nav__secure-space"
          (click)="trackEvent({ category: 'Espace Entreprise', action: 'Click Mon espace', type: 'navigation' })"
        >
          Mon espace sécurisé
        </a>
      </li>
      <li *ngIf="displayLocalMissionSecureSpace && !displayCompanySecureSpace">
        <a
          [routerLink]="['/', FeaturesRoutingEnum.Employers, 'evenement', 'mission-locale', eventId]"
          class="btn nav__secure-space"
          (click)="trackEvent({ category: 'Espace Entreprise', action: 'Click Mon espace', type: 'navigation' })"
          >Mon espace sécurisé
        </a>
      </li>
      <li *ngIf="displayCompanySecureSpace || (displayLocalMissionSecureSpace && !displayCompanySecureSpace)">
        <button
          class="btn nav__secure-space nav__secure-space__logout"
          type="button"
          (click)="logoutFromSecuredSpace.emit()"
        >
          Déconnexion
        </button>
      </li>
    </ul>
  </header>
</section>
